export interface TaskNoteDraft {
	headcount: number;
	jobVerified: boolean;
	noteText: string;
	scanSkipped: boolean;
	showNoteInput: boolean;
}

const DEFAULT_HEADCOUNT = 1;

const emptyTaskNoteDraft: TaskNoteDraft = {
	headcount: DEFAULT_HEADCOUNT,
	jobVerified: false,
	noteText: "",
	scanSkipped: false,
	showNoteInput: false
};

export const isTaskNoteDraftDirty = (draft: TaskNoteDraft): boolean =>
	draft.noteText.trim().length > 0 ||
	draft.showNoteInput ||
	draft.jobVerified ||
	draft.scanSkipped ||
	draft.headcount !== DEFAULT_HEADCOUNT;

export const rehydrateTaskNoteDraft = (draft?: Partial<TaskNoteDraft>): TaskNoteDraft => ({
	...emptyTaskNoteDraft,
	...draft
});

export default rehydrateTaskNoteDraft;
